module.exports = "./img/6c998fdbf49e2e6c916c705145093cbd.jpg";